import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.importModal';

export default defineMessages({
  headerInfo_AMBROSIA_course: {
    id: `${scope}.courseInfo`,
    defaultMessage: 'Course Info',
  },
  headerInfo_DOCX_course: {
    id: `${scope}.courseInfo`,
    defaultMessage: 'Course Info',
  },
  headerInfo_DOCX_chapter: {
    id: `${scope}.chapterInfo`,
    defaultMessage: 'Import Info',
  },
  headerInfo_EPUB_course: {
    id: `${scope}.courseInfo`,
    defaultMessage: 'Course Info',
  },
  courseName: {
    id: `${scope}.courseName`,
    defaultMessage: 'Name',
  },
  courseFormat: {
    id: `${scope}.courseFormat`,
    defaultMessage: 'Format',
  },
  courseFormatPlaceholder: {
    id: `${scope}.courseFormatPlaceholder`,
    defaultMessage: 'Select course format',
  },
  EPUB_ETEXT: {
    id: `${scope}.EPUB_ETEXT`,
    defaultMessage: 'ePub 3 (for etext)',
  },
  EPUB_BRONTE_VIEWER: {
    id: `${scope}.EPUB_BRONTE_VIEWER`,
    defaultMessage: 'ePub 3 (for Bronte Viewer)',
  },
  BRONTE_VIEWER_STITCHED_LESSON: {
    id: `${scope}.BRONTE_VIEWER_STITCHED_LESSON`,
    defaultMessage: 'Bronte Viewer (Stitched Lesson)',
  },
  WORD_STUDY_CHANNEL: {
    id: `${scope}.WORD_STUDY_CHANNEL`,
    defaultMessage: 'Word (for Study Channels)',
  },
  WORD_BVPLUGIN: {
    id: `${scope}.WORD_BVPLUGIN`,
    defaultMessage: 'Word (for Bronte Viewer)',
  },
  WORD_ETEXT: {
    id: `${scope}.WORD_ETEXT`,
    defaultMessage: 'Word (for etext)',
  },
  AMBROSIA_IMPORT: {
    id: `${scope}.AMBROSIA_IMPORT`,
    defaultMessage: 'Ambrosia import',
  },
  namePlaceholder_AMBROSIA_course: {
    id: `${scope}.courseNamePlaceholder`,
    defaultMessage: 'Enter course name',
  },
  namePlaceholder_DOCX_course: {
    id: `${scope}.courseNamePlaceholder`,
    defaultMessage: 'Enter course name',
  },
  namePlaceholder_DOCX_chapter: {
    id: `${scope}.chapterNamePlaceholder`,
    defaultMessage: 'Enter import name',
  },
  namePlaceholder_EPUB_course: {
    id: `${scope}.courseNamePlaceholder`,
    defaultMessage: 'Enter course name',
  },
  courseNameValidationIsRequired: {
    id: `${scope}.courseNameValidationIsRequired`,
    defaultMessage: 'Please enter a course title',
  },
  cloudURL: {
    id: `${scope}.cloudURL`,
    defaultMessage: 'Link to ePub file work',
  },
  cloudURLPlaceholder: {
    id: `${scope}.cloudURLPlaceholder`,
    defaultMessage: 'Input URL',
  },
  cloudURLValidationIsRequired: {
    id: `${scope}.cloudURLValidationIsRequired`,
    defaultMessage: 'Please see provide a valid file selection',
  },
  import: {
    id: `${scope}.import`,
    defaultMessage: 'Import',
  },
  next: {
    id: `${scope}.next`,
    defaultMessage: 'Next',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  unexpectedError: {
    id: `${scope}.unexpected`,
    defaultMessage: 'Sorry, some unexpected error occured',
  },
  duplicateCourseNameError: {
    id: `${scope}.duplicateCourseNameError`,
    defaultMessage: 'This name already exists.',
  },
  noFileSelected: {
    id: `${scope}.noFileSelected`,
    defaultMessage: 'No file selected',
  },
  importFile: {
    id: `${scope}.importFile`,
    defaultMessage: 'File to import',
  },
  warning: {
    id: `${scope}.warning`,
    defaultMessage:
      'Please don’t close this window or refresh this page until the upload is finished.',
  },
  uploadFile: {
    id: `${scope}.uploadFile`,
    defaultMessage: 'Upload your file',
  },
  tryAgain: {
    id: `${scope}.tryAgain`,
    defaultMessage: 'Try again',
  },
  uploadCompleted: {
    id: `${scope}.uploadCompleted`,
    defaultMessage: 'Upload completed',
  },
  importFailed: {
    id: `${scope}.importFailed`,
    defaultMessage:
      'Upload interrupted by a network error. Check your connection or keep your computer active.',
  },
});
